import type { FragmentType } from 'src/gql';
import type { Deprecated_HandleItemUpdate } from 'src/types/account';
import { useState } from 'react';
import { EditLiabilityDialog } from 'src/components/liability/edit-liability-dialog';
import TrackedButton from 'src/components/tracked/tracked-button';
import { graphql, unmaskFragment } from 'src/gql';
import { LIABILITY_DELETE_BUTTON_TEXT } from 'src/utils/liability';

import { useIsSmallScreen } from '@savvy/deprecated-shared/hooks/use-is-small-screen';

import { ViewPortfolioItemDialog } from '../views/view-portfolio-item-dialog';
import PortfolioLiabilityDescriptionRow from './portfolio-liability-description-row';
import RemoveLiabilityDialog from './remove-liability-dialog';
import { ViewLiabilityDialogDetailRows } from './view-liability-dialog-detail-rows';

export const ViewLiabilityDialogFragment = graphql(/* GraphQL */ `
  fragment ViewLiabilityDialog on Liability {
    ...EditLiabilityDialog
    ...PortfolioLiabilityDescriptionRow
    ...RemoveLiabilityDialog
    ...ViewLiabilityDialogDetailRows
  }
`);

export default function ViewLiabilityDialog({
  liabilityFrag,
  onEdit,
  onClose,
}: {
  readonly liabilityFrag: FragmentType<typeof ViewLiabilityDialogFragment>;
  readonly onEdit: Deprecated_HandleItemUpdate;
  readonly onClose: () => void;
}) {
  const liability = unmaskFragment(ViewLiabilityDialogFragment, liabilityFrag);
  const [isEditing, setIsEditing] = useState(false);
  const [isRemoving, setIsRemoving] = useState(false);
  const isSmallScreen = useIsSmallScreen();

  if (isEditing) {
    return (
      <EditLiabilityDialog
        liabilityFrag={liability}
        onClose={() => {
          setIsEditing(false);
        }}
        onBack={() => {
          setIsEditing(false);
        }}
        onEdit={onEdit}
      />
    );
  }

  if (isRemoving) {
    return (
      <RemoveLiabilityDialog
        liabilityFrag={liability}
        onClose={() => {
          setIsRemoving(false);
        }}
        onRemove={onEdit}
      />
    );
  }
  return (
    <ViewPortfolioItemDialog
      deleteButton={
        <TrackedButton
          elementName="view-liability-dialog-delete-button"
          variant="secondary"
          onClick={() => {
            setIsRemoving(true);
          }}
          className={isSmallScreen ? 'w-[156px]' : undefined}
        >
          {LIABILITY_DELETE_BUTTON_TEXT}
        </TrackedButton>
      }
      descriptionRow={<PortfolioLiabilityDescriptionRow liabilityFrag={liability} />}
      detailRows={<ViewLiabilityDialogDetailRows liabilityFrag={liability} />}
      editButton={
        <TrackedButton
          elementName="view-liability-dialog-edit-button"
          variant="secondary"
          onClick={() => {
            setIsEditing(true);
          }}
          className={isSmallScreen ? 'w-[156px]' : undefined}
        >
          Edit details
        </TrackedButton>
      }
      onClose={onClose}
    />
  );
}
